import { render, staticRenderFns } from "./SalesRecapExportDetails_Details.vue?vue&type=template&id=b2dbfe7c&"
import script from "./SalesRecapExportDetails_Details.vue?vue&type=script&lang=js&"
export * from "./SalesRecapExportDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports